import { numTofixed, accDivide } from '@/utils/math'
export default {
  inject: ['getTaskMonitoringList', 'getDigitalPlantList', 'getProgressList'],
  watch: {
    taskMonitoringList: {
      handler (nVal, oVal) {
        this.processingTaskMonitoringList && this.processingTaskMonitoringList(nVal, oVal)
      },
      immediate: true,
      deep: true
    },
    digitalPlantList: {
      handler (nVal, oVal) {
        this.processingDigitalPlantList && this.processingDigitalPlantList(nVal, oVal)
      },
      immediate: true,
      deep: true
    }
  },
  filters: {
    // 毫克转吨,默认保留两位小数
    microgramToTonFilter (value, num = 2) {
      return numTofixed(accDivide(value, 1000000000), num)
    }
  },
  data () {
    return {
      taskMonitoringList: this.getTaskMonitoringList(),
      digitalPlantList: this.getDigitalPlantList(),
      progressList: this.getProgressList()
    }
  },
  methods: {
    // 毫克转吨,默认保留两位小数
    microgramToTon (value, num = 2) {
      return numTofixed(accDivide(value, 1000000000), num)
    }
  }
}
